import exceljs from "exceljs";
// import moment from "moment";
import { saveAs } from "file-saver";
import i18n from '@/plugins/vue-i18n';;
export class ExportMeter {
  constructor() {
    // excel file type
  }
  static async saveFile(workbook, fileName) {
    const buffer = await workbook.xlsx.writeBuffer();
    const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    const fileExtension = ".xlsx";
    const blob = new Blob([buffer], { type: fileType });
    return saveAs(blob, fileName + fileExtension);
  }

  static async exportMeterRecord(meters, hashMetersUnit, hashArea, month, year, type) {
    const workbook = new exceljs.Workbook();
    const worksheet = workbook.addWorksheet(type);
    worksheet.columns = [
      {
        header: i18n.t('rank'),
        key: 1,
        width: 10,
        style: {
          alignment: {
            horizontal: "center",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('area.space'),
        key: 2,
        width: 10,
        style: {
          alignment: {
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('bill.customer_market_id'),
        key: 3,
        width: 20,
        style: {
          alignment: {
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('account.fullname'),
        key: 4,
        width: 20,
        style: {
          alignment: {
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('meter.meter_name'),
        key: 5,
        width: 15,
        style: {
          alignment: {
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('meter.previous_unit_number'),
        key: 6,
        width: 15,
        style: {
          alignment: {
            horizontal: "right",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('meter.current_unit_number'),
        key: 7,
        width: 15,
        style: {
          alignment: {
            horizontal: "right",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('meter.number_of_units'),
        key: 8,
        width: 15,
        style: {
          alignment: {
            horizontal: "right",
            vertical: "center"
          }
        }
      },
      {
        header: i18n.t('note'),
        key: 9,
        width: 50,
        style: {
          alignment: {
            vertical: "center"
          }
        }
      }
    ]
    let index = 0;
    for (let meter of meters) {
      // setRowMeter(meter.mainMeter)
      for (let subMeter of meter.subMeters) {
        setRowMeter(subMeter)
      }
    }
    function setRowMeter(meter) {
      index++;
      let objUnit = hashMetersUnit[meter.objectId] ? hashMetersUnit[meter.objectId] : { previousUnit: 0, unit: 0 }
      let area = hashArea[meter.area.objectId] || {}
      let contract;
      let customer;
      let customerName;
      if (area && area.contract) contract = area.contract
      if (contract && contract.customer) customer = contract.customer

      if (customer) {
        if (customer.type == "company") customerName = customer.companyName || ""
        else customerName = `${customer.firstName} ${customer.lastName}` || ""
      }

      let usedUnit = 0
      let note = ''
      if (hashMetersUnit[meter.objectId] && hashMetersUnit[meter.objectId].isExceed) {
        usedUnit = parseFloat(hashMetersUnit[meter.objectId].unit) - (hashMetersUnit[meter.objectId].previousUnit || 0) + hashMetersUnit[meter.objectId].unitLimit + 1
        note = `${i18n.t('meter.full_meter')}, ${i18n.t('meter.maximum_unit')} ${hashMetersUnit[meter.objectId].unitLimit}`
      } else if (hashMetersUnit[meter.objectId] && hashMetersUnit[meter.objectId].isChanged) {
        usedUnit = hashMetersUnit[meter.objectId].oldUnit - hashMetersUnit[meter.objectId].newUnit - (hashMetersUnit[meter.objectId].previousUnit || 0) + parseFloat(hashMetersUnit[meter.objectId].unit)
        note = `${i18n.t('meter.change_meter')}, ${i18n.t('meter.old_meter_unit')} ${hashMetersUnit[meter.objectId].oldUnit} ${i18n.t('meter.new_meter_unit')} ${hashMetersUnit[meter.objectId].newUnit}`
      } else if (hashMetersUnit[meter.objectId]) {
        usedUnit = parseFloat(hashMetersUnit[meter.objectId].unit) - (hashMetersUnit[meter.objectId].previousUnit || 0)
        note = ``
      }


      worksheet.addRow({
        1: index,
        2: meter.area.name,
        3: contract ? contract.customerMarketId || "" : "",
        4: customerName,
        5: meter.name ? meter.name : meter.isMain ? i18n.t('main') : i18n.t('additional'),
        6: objUnit.previousUnit || 0,
        7: objUnit.unit || 0,
        8: usedUnit,
        9: note
      })
    }
    return this.saveFile(workbook, `${type}-${month}-${year}`);
  }
}